<template>
  <div>
    <h2>Carrito</h2>

    <div class="flex flex-wrap">
      <div
        v-for="(product, index) in cart.products"
        :key="index"
        class="card w-full sm:w-fit h-fit sm:mr-4 mt-2"
      >
        <img
          :src="getImage(product)"
          alt=""
          class="w-12 h-12 rounded object-contain object-center mx-auto"
        />

        <div class="flex flex-col">
          <p class="font-medium text-primary-500">
            {{ product.name }}
          </p>
          <p class="text-sm font-medium">
            Precio unitario:
            {{ integerToCurrency(product.unit_price) }}
          </p>

          <div class="flex items-center space-x-3 mt-2 mx-auto">
            <button
              class="font-semibold border border-primary-500 rounded-full w-8 h-8"
              @click="$store.dispatch('subtractQuantityToCart', product.id)"
            >
              -
            </button>
            <p class="w-6 text-center">{{ product.quantity }}</p>
            <button
              v-if="product.quantity < product.stock"
              class="font-semibold border border-primary-500 rounded-full w-8 h-8"
              @click="$store.dispatch('addQuantityToCart', product.id)"
            >
              +
            </button>
          </div>

          <button class="delete-button mt-2 mx-auto" @click="removeFromCart(product)">
            Remover
          </button>
        </div>
      </div>
    </div>

    <div v-if="cart.products.length > 0" class="card mt-6">
      <div class="flex justify-between mt-2">
        <p class="text-sm font-medium">Subtotal:</p>
        <p class="text-sm font-medium">
          {{ integerToCurrency(subtotal) }}
        </p>
      </div>

      <div class="flex justify-between mt-2">
        <p class="text-sm font-medium">Precio de envío:</p>
        <p class="text-sm font-medium">
          {{ integerToCurrency(shippingPrice) }}
        </p>
      </div>
      <div class="flex justify-between mt-2">
        <p class="text-sm font-semibold">Total:</p>
        <p class="text-sm font-semibold">
          {{ integerToCurrency(total) }}
        </p>
      </div>

      <div v-if="total" class="mt-4">
        <div class="flex flex-col w-full">
          <label for="payment_frequency">Dirección de entrega</label>

          <div v-if="address">
            <p class="text-sm">
              {{ address.street }} {{ address.exterior_number
              }}{{
                address.interior_number ? " " + address.interior_number : ""
              }}
            </p>
            <p v-if="address.neighborhood" class="text-sm">
              {{ address.neighborhood }}
            </p>
            <p class="text-sm">{{ address.city }}, {{ address.state.name }}</p>
            <p class="text-sm">México</p>
            <p class="text-sm">{{ address.zip_code }}</p>
          </div>
        </div>

        <label class="mt-6" for="payment_method">Método de pago</label>

        <div v-if="paymentMethods && paymentMethods.length > 0">
          <custom-select
            id="payment_method"
            v-model="paymentMethod"
            :options="getPaymentMethodOptions()"
          />
        </div>

        <primary-button
          v-if="total && paymentMethod"
          class="mx-0 mt-6"
          :loading="loading"
          @buttonClicked="pay"
          >Pagar</primary-button
        >
      </div>
    </div>

    <div v-else>No hay productos en el carrito</div>
  </div>
</template>

<script>
import StripeIcon from "@/icons/StripeIcon";
import SafeIcon from "@/icons/SafeIcon";
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { mapState } from "vuex";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Cart",

  components: {
    StripeIcon,
    SafeIcon,
  },

  data() {
    return {
      loading: false,
      defaultImage: require("@/assets/paw.png"),
      address: null,
      paymentMethods: null,
      paymentMethod: null,
      shippingPrice: null,
    };
  },

  computed: {
    ...mapState({
      cart: "cart",
    }),

    subtotal() {
      return this.cart.products.reduce((total, product) => {
        return total + product.unit_price * product.quantity;
      }, 0);
    },

    total() {
      if (!this.shippingPrice) {
        return null;
      }

      return this.subtotal + this.shippingPrice;
    },
  },

  mixins: [validationErrors],

  created() {
    this.$store.commit("setSelectedTab", "cart");

    this.loadBranch();
    this.calculateShippingPrice();
    this.loadPaymentMethods();
  },

  methods: {
    integerToCurrency,

    async loadBranch() {
      this.loading = true;

      try {
        const response = await api.branches.getById(
          this.$route.params.branchId
        );
        this.address = response.address;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    async calculateShippingPrice() {
      this.loading = true;

      try {
        const response = await api.checkout.calculateShippingPrice(
          this.$route.params.branchId
        );
        this.shippingPrice = response.shipping_price;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    async loadPaymentMethods() {
      this.loading = true;

      try {
        this.paymentMethods = (await api.paymentMethods.getAll()).data;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getImage(product) {
      if (!product.image_url) {
        return this.defaultImage;
      }

      return product.image_url;
    },

    removeFromCart(product) {
      this.$store.dispatch("removeFromCart", product);
      this.$store.dispatch(
        "successSnack",
        "Producto removido exitosamente del carrito"
      );
    },

    getPaymentMethodOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.paymentMethods.forEach((paymentMethod) => {
        const label = `**** ${paymentMethod.card.last4} - ${paymentMethod.card.exp_month}/${paymentMethod.card.exp_year}`;

        options.push({
          value: paymentMethod.id,
          label: label,
        });
      });

      return options;
    },

    validateForm() {
      this.errors = {};

      if (!this.payment.cardholder_name) {
        this.errors["name"] = ["Campo requerido."];
      }

      return Object.keys(this.errors).length === 0;
    },

    async pay() {
      const products = this.cart.products.map((product) => {
        return { id: product.id, quantity: product.quantity };
      });

      const request = {
        shipping_price: this.shippingPrice,
        total: this.total,
        payment_method: this.paymentMethod,
        branch_id: this.$route.params.branchId,
        products: products,
      };

      this.loading = true;

      try {
        const response = await api.checkout.pay(request);
        this.$store.dispatch("successSnack", response.message);
        this.$store.dispatch("clearCart");
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },
  },
};
</script>